import type { IconData } from '@stacksjs/iconify-core'

export const la1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGf6QIIdus\"><path fill-opacity=\".7\" d=\"M177.2 0h708.6v708.7H177.2z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGf6QIIdus)\" transform=\"translate(-128)scale(.72249)\"><path fill=\"#ce1126\" d=\"M0 0h1063v708.7H0z\"/><path fill=\"#002868\" d=\"M0 176h1063v356.6H0z\"/><path fill=\"#fff\" d=\"M684.2 354.3a152.7 152.7 0 1 1-305.4 0a152.7 152.7 0 0 1 305.4 0\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default la1x1
